
/* injects from baggage-loader */

CKEDITOR.plugins.add( 'customlink', {
  requires: 'panelbutton',
  init: function( editor ) {
    var allowed = 'a[!href]',
      required = 'a[href]',
      plugin = CKEDITOR.plugins.link;

    if ( CKEDITOR.dialog.isTabEnabled( editor, 'link', 'advanced' ) )
      allowed = allowed.replace( ']', ',accesskey,charset,dir,id,lang,name,rel,tabindex,title,type]{*}(*)' );
    if ( CKEDITOR.dialog.isTabEnabled( editor, 'link', 'target' ) )
      allowed = allowed.replace( ']', ',target,onclick]' );

    function getCompiledProtectionFunction( editor ) {
      var emailProtection = editor.config.emailProtection || '',
        compiledProtectionFunction;

      // Compile the protection function pattern.
      if ( emailProtection && emailProtection != 'encode' ) {
        compiledProtectionFunction = {};

        emailProtection.replace( /^([^(]+)\(([^)]+)\)$/, function( match, funcName, params ) {
          compiledProtectionFunction.name = funcName;
          compiledProtectionFunction.params = [];
          params.replace( /[^,\s]+/g, function( param ) {
            compiledProtectionFunction.params.push( param );
          } );
        } );
      }

      return compiledProtectionFunction;
    }
    this.compiledProtectionFunction = getCompiledProtectionFunction( editor );

    editor.ui.add( 'customlink', CKEDITOR.UI_PANELBUTTON, {
      label: 'customlink',
      className: 'cke_customlink',
      title: 'customlink',
      modes: { wysiwyg: 1 },
      editorFocus: 1,
      toolbar: 'customlink,' + 10,
      allowedContent: allowed,
      requiredContent: required,
      panel: {
        css: CKEDITOR.skin.getPath( 'editor' ),
        attributes: { role: 'listbox', 'aria-label': 'lang.panelTitle' }
      },
      onBlock: function(panel, block) {
        $(block.element.$)
          .addClass('cke_customlink_body')
          .append(
            '<input type="text" class="input input_nano ms-input_border" id="panel-input-link-value" placeholder="http://your-site.com">' +
            '<div class="checkbox-wrapper ms-checkbox">' +
              '<input id="panel-checkobx-link-target" type="checkbox" class="checkbox">' +
              '<label for="panel-checkobx-link-target" title="Mark a message" class="checkbox-label-wrapper">' +
                '<div class="checkbox-label checkbox-label_small button_border fl">' +
                  '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" class="icon-check">' +
                    '<rect x="2.4" y="3.4" transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 15.7777 2.2917)" width="10" height="2" class="icon-check__rect"></rect>' +
                    '<rect x="0.2" y="4.8" transform="matrix(0.7071 0.7071 -0.7071 0.7071 5.0497 -0.5358)" width="6" height="2" class="icon-check__rect"></rect>' +
                  '</svg>' +
                '</div><span class="label-text">' + editor.config.OpenInNewWindow + '</span>' +
              '</label>' +
            '</div>');
      },
      onOpen: function(){

        var defaultValue,
            self = this,
            inputLink = $('.cke_panel_frame').contents().find('#panel-input-link-value'),
            checkboxTarget = $('.cke_panel_frame').contents().find('#panel-checkobx-link-target'),
            selectedElementTag = editor.getSelection().getStartElement(),
            optionsJustclick = window.justclick;

        // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
        // Поиск ссылки у выделенного элемента
        // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-

        var parents = [],
            parentsTags = [],
            par = [],
            parTags = [];

        parents = selectedElementTag.getParents()
        for(var i = 0; i < parents.length; i++){
          parentsTags.push(parents[i].$.tagName)
        }
        var indexTag = parentsTags.indexOf('A');


        if (indexTag > -1){
          selectedElementTag = parents[indexTag]
        } else {
          style = new CKEDITOR.style( { element : 'a', type : CKEDITOR.STYLE_INLINE, attributes: {"data-editing": true}} );
          style.apply(editor.document);
          if (selectedElementTag.findOne("[data-editing]") == null) {
            par = selectedElementTag.getParents()
            for(var i = 0; i < par.length; i++){
              parTags.push(par[i].$.tagName)
            }
            var indexTag = parTags.indexOf('A');
            selectedElementTag = par[indexTag];
          }
          else
            selectedElementTag = selectedElementTag.findOne("[data-editing]")
        }


        // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
        // Значение по умолчанию
        // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-

        if (plugin.getSelectedLink(editor) && selectedElementTag) {
          defaultValue = $(selectedElementTag).attr("href");

          if (!defaultValue && optionsJustclick && optionsJustclick.useNextPageUrl) {
            defaultValue = '#nextPage';
          }

          var defaultCheck = selectedElementTag.$.target
        }

        if (defaultCheck) {
          $(checkboxTarget).prop('checked', true);
        } else {
          $(checkboxTarget).prop('checked', false);
        }


        // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-
        // Запись значений в параметры
        // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-

        $(checkboxTarget)
          .unbind('change')
          .on('change', function(e){
            if ($(this).is(':checked')) {
              selectedElementTag.setAttributes({
                'target': '_blank'
              })
            } else {
              selectedElementTag.setAttributes({
                'target': ''
              })
            }
          });

        $(inputLink).val(defaultValue);

        this.updateSelectedElementTag($(inputLink), selectedElementTag);

        $(inputLink).unbind('keyup').on('keyup', function(e) {
          self.updateSelectedElementTag($(this), selectedElementTag);
        });
      },

      updateSelectedElementTag: function($inputLink, selectedElementTag) {
        var inputLinkValue = $inputLink.val();

        if (inputLinkValue == 0) {
          selectedElementTag.removeAttributes(['href', 'data-cke-saved-href', 'target', 'id'])
        } else {
          selectedElementTag.setAttributes({
            'href': inputLinkValue,
            'data-cke-saved-href': inputLinkValue
          });
        }
      },

      protocolPresent: function (str) {
        const pattern = new RegExp(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9\+.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[.\!\/\\w]*))?)/);

        return pattern.test(str);
      },

      onClose: function() {
        var parents = [],
            parentsTags = [],
            indexTag,
            inputLinkValue = $('.cke_show .cke_panel_frame').contents().find('#panel-input-link-value').val()
            selectedElementTag = editor.getSelection().getStartElement();

        parents = selectedElementTag.getParents()
        for(var i = 0; i < parents.length; i++){
          parentsTags.push(parents[i].$.tagName)
        }
        indexTag = parentsTags.indexOf('A');

        if(indexTag >= 0){
          selectedElementTag = parents[indexTag]
        } else {
          selectedElementTag = selectedElementTag.getParent()
        }

        if (inputLinkValue == 0) {
          $('.cke_panel_frame').contents().find('#panel-checkobx-link-target').prop('checked', false);
          var style = new CKEDITOR.style( { element: 'a', type: CKEDITOR.STYLE_INLINE, alwaysRemoveElement: 1 } );
          editor.removeStyle( style );
        } else {
          const link = selectedElementTag && (selectedElementTag.getAttribute('href')) || selectedElementTag.data('cke-saved-href') || '';
          const parseLink = plugin.parseLinkAttributes(editor, selectedElementTag);
          const linkAttrs = plugin.getLinkAttributes(editor, parseLink);

          if (parseLink.type === 'url' && !!parseLink.url.protocol === false && this.protocolPresent(link)) {
            $(selectedElementTag.$).attr({'href': link, 'data-cke-saved-href': link});
          } else {
            $(selectedElementTag.$).attr({'href': linkAttrs.set.href, 'data-cke-saved-href': linkAttrs.set['data-cke-saved-href']});
          }
        }
        $("[data-editing]").removeAttr("data-editing")
      }
    });
  },

  afterInit: function( editor ) {
    // Empty anchors upcasting to fake objects.
    editor.dataProcessor.dataFilter.addRules( {
      elements: {
        a: function( element ) {
          if ( !element.attributes.name )
            return null;

          if ( !element.children.length )
            return editor.createFakeParserElement( element, 'cke_anchor', 'anchor' );

          return null;
        }
      }
    } );

    var pathFilters = editor._.elementsPath && editor._.elementsPath.filters;
    if ( pathFilters ) {
      pathFilters.push( function( element, name ) {
        if ( name == 'a' ) {
          if ( CKEDITOR.plugins.link.tryRestoreFakeAnchor( editor, element ) || ( element.getAttribute( 'name' ) && ( !element.getAttribute( 'href' ) || !element.getChildCount() ) ) )
            return 'anchor';
        }
      } );
    }
  }
} );




// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/ckeditor/plugins/customlink/plugin.js